import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    retrieved: null,
    updated: null,
    violations: null,
    languages: null,
    translation: null,
    translationError: '',
    translationLoading: false,
    languagesLoading: false
  },
  actions,
  getters,
  mutations
}
